<div *ngIf="!!person; else loading;">
  <div id="person-detail-component">
    <div class="bigfield"><span class="h2">{{person.name}}</span></div>
    <div class="field"><label>location: </label>{{person.location}}</div>
    <div class="field"><label>email: </label><a href="mailto:{{person.email}}">{{person.email}}</a></div>
    <div class="field"><label>phone: </label><a href="tel:{{person.phone}}">{{person.phone}}</a></div>
    <div class="field"><label>guid: </label>{{person.guid}}</div>
    <div class="field"><label>score: </label>{{person.score}}</div>
    <div class="field"><label>type: </label>
      <ng-container *ngIf="editable; else static" class="editable">
        <mat-form-field class="person_type_select">
          <mat-select #person_type required [(ngModel)]="person.person_type_id" name="person_type_id">
            <mat-option *ngFor="let person_type of personTypes" [ngValue]="person_type.person_type_id">
              {{person_type.person_type_description}} </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- div *ngIf="CanAdminister()" class="panel" -->
        <button (click)="saveChanges()" class="btn btn-primary">Save</button>
        <!-- /div -->
        <!-- div class="panel" -->
        <button (click)="cancelChanges()" class="btn">Cancel</button>
        <!-- /div -->
      </ng-container>
      <ng-template #static>
        {{personTypeDescription(person)}}
        <div *ngIf="CanAdminister()" class="panel">
          <button (click)="setEditing()" class="btn btn-primary">Edit</button>
        </div>
      </ng-template>
    </div>
  </div>

  <div *ngIf="person.response_count > 0">
    <br />
    <h2>{{person.response_count}} responses</h2>
  </div>
</div>
<ng-template #loading>
  Loading...
</ng-template>